/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Chaterrorgeneric2Inputs */

const en_chaterrorgeneric2 = /** @type {(inputs: Chaterrorgeneric2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Something went wrong: ${i?.message}`)
};

const pt_chaterrorgeneric2 = /** @type {(inputs: Chaterrorgeneric2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Algo correu mal: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Something went wrong: {message}" |
*
* @param {Chaterrorgeneric2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const chaterrorgeneric2 = /** @type {((inputs: Chaterrorgeneric2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chaterrorgeneric2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chaterrorgeneric2(inputs)
	return pt_chaterrorgeneric2(inputs)
});
export { chaterrorgeneric2 as "chatErrorGeneric" }